import Axios from 'config/service.config'
import envConfig from 'config/env_config'

export const getCampaignsByPartnerAndService = async (partner, service, calendarDate) => {
  try {
    const { month, year } = calendarDate
    const { data } = await Axios({
      baseURL: envConfig.partner,
      url: `/campaign/list/${partner}/${service}`,
      params: { month, year, visibleTo: 'CLIENT' }
    })
    return data
  } catch (error) {
    return error.response
  }
}
